<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import NumberFormat from "@/mixins/NumberFormat";
import VIconTooltip from "@/components/commonComponents/VIconTooltip.vue";
import UserAuth from "@/mixins/UserAuth";

export default {
    name: "DictionariesSyncItem",
    components: {
        VIconTooltip,
        AjaxLoad,
    },
    mixins: [
        NumberFormat,
        UserAuth,
    ],
    props: {
        url: {
            type: String,
            required: true,
        },
        heading: {
            type: String,
            required: true,
        },
        incrementalSync: {
            type: Boolean,
        },
    },
    data() {
        return {
            isSubmit: false,
            notifyOptions: {
                title: this.heading,
            },
        };
    },
    computed: {
        isDisabled() {
            return this.isSubmit || !this.user?.permissions?.byModule?.dictionary_sync?.canUpdate;
        },
    },
    methods: {
        doSync(params = {}) {
            this.isSubmit = true;
            this.$api.put(this.url, params)
                .then(response => {
                    const data = response.data.data,
                        message = [
                            'Справочник успешно обновлен.',
                            'Обновлено записей: ' + this.prettyInt(data.affected),
                            'Время: ' + this.prettyFloat(data.time) + ' сек.',
                        ].join('<br>');
                    this.notifySuccess(message);
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.$refs.ajax.load();
                    this.isSubmit = false;
                });
        },
        onClickSyncInc() {
            this.doSync({full: 0});
        },
        onClickSyncFull() {
            this.doSync({full: 1});
        },
    },
}
</script>

<template>
    <ajax-load
        ref="ajax"
        :url="url"
        :transform="response => response.data.data"
        v-slot="{data, resolved}"
    >
        <v-list-item class="dictionary-list-item">
            <v-list-item-content>
                <v-list-item-title>{{ heading }}</v-list-item-title>
                <v-list-item-subtitle>
                    <template v-if="data?.max_updated_at">
                        Макс. дата обновления элементов справочника &mdash;
                        {{ data.max_updated_at | moment('DD.MM.Y HH:mm:ss') }}
                    </template>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="data">
                    <slot v-bind="{data}"></slot>
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="text-no-wrap align-self-center">
                <v-row>
                    <v-col>
                        <v-icon-tooltip
                            v-if="incrementalSync"
                            :disabled="!resolved || isDisabled"
                            @click="onClickSyncInc"
                            icon="mdi-database-refresh-outline"
                        >
                            Инкрементальная синхронизация
                        </v-icon-tooltip>
                    </v-col>
                    <v-col>
                        <v-icon-tooltip
                            :disabled="!resolved || isDisabled"
                            @click="onClickSyncFull"
                            icon="mdi-database-refresh"
                        >
                            Полная синхронизация
                        </v-icon-tooltip>
                    </v-col>
                </v-row>
            </v-list-item-action>
        </v-list-item>
    </ajax-load>
</template>

<style scoped lang="scss">
.dictionary-list-item {
  height: 100%;
}
.v-list-item {
  height: 100%;
}
::v-deep .v-list-item__content {
  align-self: flex-start;
}
</style>
